import Validator from "@/validators/Validator";
import {ValidationRuleInput} from "@/declarations/ValidationRuleInput";
import i18n from "@/i18n";
import {isEmpty} from "@/helpers/functions_asi";

export class NumberValidator extends Validator {

	public constructor(label: string, translateLabel: boolean = true) {
		super(label, translateLabel);
	}

	protected validate(value: ValidationRuleInput): boolean | string {
		if (value === null|| isEmpty(value.toString())) return this.success();

		if (!isNaN(Number(value))) {
			return this.success();
		}

		return this.fail();
	}

	protected validationFailedMessage(label: string, reason: number | null = null): string {
		return i18n.t('validation.notANumber', {field: label}).toString();
	}

}
